import { SvgIcon } from '@material-ui/core'

export const WifiIcon = props => (
  <SvgIcon {...props} style={{ fill: 'none' }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M14 22.75H14.0117M26.6075 10.1509C23.2862 7.10732 18.8599 5.25 13.9999 5.25C9.13986 5.25 4.71362 7.10732 1.39227 10.1509M5.52061 14.2835C7.78175 12.2916 10.7498 11.0833 14 11.0833C17.2502 11.0833 20.2182 12.2916 22.4794 14.2835M18.3147 18.4043C17.1258 17.4723 15.6277 16.9167 13.9999 16.9167C12.3474 16.9167 10.8287 17.4893 9.63129 18.4468"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
)
